export default "/images/52b111caa8208df9e77d4a8613788d29.png";